export default "/fonts/vendor/katex/dist/KaTeX_Math-Italic.ttf?8a5f936332e8028c7278a3a25db00925";